module.exports = __webpack_public_path__ + "img/default-crypto.46c8e49c.svg";